import styled from 'styled-components';
import { motion } from 'framer-motion6';
import { FaCaretRight } from 'react-icons/fa';
import { th } from 'style/theme';

export const Wrapper = styled.div`
  max-width: 900px;
  pointer-events: none;
`;

export const ShortWarning = styled.div`
  margin-top: 24px;
  font-size: 16px;
  font-weight: 500;
  color: ${th('colors.black')};
  pointer-events: all;

  > span {
    display: inline-flex;
    align-items: center;
    font-weight: 700;
    user-select: none;
    cursor: pointer;
  }
`;

export const Icon = styled(FaCaretRight)`
  font-size: 18px;
  color: inherit;
  margin-left: 4px;
  transition: transform 0.3s;

  ${({ $isOpen }) => $isOpen && `transform: rotate(90deg);`}
`;

export const StyledPersonalInfoNote = styled(motion.div)`
  font-size: 14px;
`;
